import React from "react";

export const Input = ({
  input,
  label,
  placeholder,
  type,
  meta: { touched, error, warning }
}) => {
  const classError = (touched && (error || warning)) ? "form-control col-md-12 mb-2 zero-input-card zero-height-56 is-invalid" : "form-control col-md-12 mb-2 zero-input-card zero-height-56";
  return (
    <div className="form-group">
      {label && <label htmlFor={input.name}>{label}</label>}
      <input {...input} id={input.name} className={classError} placeholder={placeholder} type={type} />
        {touched &&
          ((error && <div className="text-danger" role="alert">{error}</div>) ||
            (warning && <div className="text-warning" role="alert">{warning}</div>))}
    </div>
  );
};

export const Textarea = ({
  input,
  label,
  placeholder,
  type,
  rows=4,
  meta: { touched, error, warning }
}) => {
  const classError = (touched && (error || warning)) ? "form-control col-md-12 mb-2 is-invalid" : "form-control col-md-12 mb-2";
  return (
    <div className="form-group">
      {label && <label htmlFor={input.name}>{label}</label>}
      <textarea {...input} id={input.name} className={classError} placeholder={placeholder} type={type} style={{height: rows+ 'em'}} />
        {touched &&
          ((error && <div className="text-danger" role="alert">{error}</div>) ||
            (warning && <div className="text-warning" role="alert">{warning}</div>))}
    </div>
  );
};

export const Checkbox = ({
  input,
  label,
  type,
  children,
  meta: { touched, error, warning }
}) => {
  const classError = (touched && (error || warning)) ? "form-check-input is-invalid" : "form-check-input";
  return (
    <div className="form-group">
      <input {...input} id={input.name} className={classError} type={type} />
      {label && <label htmlFor={input.name}>{label}</label>}{children}
        {touched &&
          ((error && <div className="text-danger" role="alert">{error}</div>) ||
            (warning && <div className="text-warning" role="alert">{warning}</div>))}
    </div>
  );
};

export const Radio = ({
  input,
  label,
  type,
  children,
  meta: { touched, error, warning }
}) => {
  const classError = (touched && (error || warning)) ? "form-check-input is-invalid" : "form-check-input";
  return (
    <div>
      <label><input {...input} id={input.name} className={classError} type={type} />
      {label && label}{children}
      </label>
        {touched &&
          ((error && <div className="text-danger" role="alert">{error}</div>) ||
            (warning && <div className="text-warning" role="alert">{warning}</div>))}
    </div>
  );
};

const adaptFileEventToValue = delegate => e => delegate(e.target.files[0]);

export const File = ({
  input,
  label,
  onChange,
  onBlur,
  placeholder,
  meta: { touched, error, warning }
}) => {
  
  const classError = (touched && (error || warning)) ? "form-control-file mb-2 is-invalid" : "form-control-file mb-2";
  return (
    <div className="form-group">
      {label && <label htmlFor={input.name}>{label}</label>}
      <input 
        id={input.name} 
        onChange={(e) => {
          input.onChange(e.target.files[0])
        }}
        onBlur={adaptFileEventToValue(onBlur)}
        {...input} 
        value={input.value === '' || input.value == null ? undefined : undefined}
        className={classError} 
        placeholder={placeholder} 
        type="file" />
        {touched &&
          ((error && <div className="text-danger" role="alert">{error}</div>) ||
            (warning && <div className="text-warning" role="alert">{warning}</div>))}
    </div>
  );
};